import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import {
  DateRangeEvent,
  DateRangePresetType,
  ProcessingState,
  Tab,
} from '@services/core-services/models';
import {
  AnalyticsInfo,
  AnalyticsInterval,
  AnalyticsRangeContext,
  ComparePeriod,
} from '@services/analytics-services/core';
import { ProductAnalyticsService, ProductStats } from '@services/analytics-services/products';

import { DateRangeService } from '@enginuity/core/molecules/date-range/date-range.service';

const TABS: Tab[] = [
  {
    label: 'Overview',
    id: 'overview',
  },
  {
    label: 'Orders',
    id: 'orders',
  },
  // {
  //   label: 'Revenue & sales',
  //   id: 'revenue',
  // },
  {
    label: 'Products',
    id: 'top-products',
  },
  /*{
    label: 'Marketing campaigns',
    id: 'campaigns',
  },*/
  {
    label: 'Customers',
    id: 'customers',
  },
  /* {
    label: 'Inventory',
    id: 'inventory',
  },*/
  {
    label: 'Shipment & fulfillment',
    id: 'shipment',
  },
  {
    label: 'Payments',
    id: 'payments',
  },
  {
    label: 'Insights & Analytics',
    id: 'insights',
  },
];

@Injectable()
export class DashboardStore {
  private comparePeriod = new BehaviorSubject<ComparePeriod>(ComparePeriod.Custom);
  private context = new BehaviorSubject<AnalyticsRangeContext>({
    ...this.getDefaultRange(DateRangePresetType.Today),
    interval: AnalyticsInterval.Hour,
  });
  private productAnalytics = new BehaviorSubject<AnalyticsInfo<ProductStats> | undefined>(
    undefined
  );

  private errorMessage = new BehaviorSubject<any>('');

  private loader = new BehaviorSubject<ProcessingState>(ProcessingState.Loading);
  private tabs = new BehaviorSubject<Tab[]>(TABS);

  constructor(
    private dateRangeService: DateRangeService,
    private productAnalyticsService: ProductAnalyticsService
  ) {}

  getDefaultRange(preset: DateRangePresetType): DateRangeEvent {
    const { range, compare } = this.dateRangeService.getDateRangeContext(DateRangePresetType.Today);
    return {
      range,
      compare,
      preset,
    };
  }

  getComparePeriod() {
    return this.comparePeriod.asObservable();
  }

  setComparePeriod(period: ComparePeriod) {
    this.comparePeriod.next(period);
  }

  getRangeContextSnapshot() {
    return this.context.getValue();
  }

  getRangeContext() {
    return this.context.asObservable();
  }

  setRangeContext(range: AnalyticsRangeContext) {
    this.context.next(range);
  }

  getLoader(): Observable<ProcessingState> {
    return this.loader.asObservable();
  }

  getTabs() {
    return this.tabs.asObservable();
  }

  getErrorMessage() {
    return this.errorMessage.asObservable();
  }
  getProductAnalytics() {
    return this.productAnalytics.asObservable();
  }

  loadProductsAnalytics() {
    const context = this.context.getValue();
    const { range, compare, interval, preset } = context;
    return this.productAnalyticsService
      .getAnalytics({
        preset: preset as DateRangePresetType,
        range,
        compare,
        interval,
      })
      .pipe(tap(analytics => this.productAnalytics.next(analytics)));
  }
}
